import { GAME_ID, REDUX_ACTIONS, QUESTION_COUNT, WORD_STAGE } from '../data/constants';

const initialState = {
  // Round details
  level: 0,
  wordStage: WORD_STAGE.SYNONYM,
  // How many questions answered?
  questionCount: 0,
  // How many questions answered correctly?
  masteryPoints: 0,
};

export default (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) return state;

  switch (type) {
    case REDUX_ACTIONS.QUICK_ROUND:
      return {
        ...state,
        questionCount: QUESTION_COUNT,
        masteryPoints: payload ? QUESTION_COUNT : 0,
      };

    case REDUX_ACTIONS.SET_LEVEL:
      return { ...state, level: payload };

    case REDUX_ACTIONS.SET_WORD_STAGE:
      return { ...state, wordStage: payload };

    case REDUX_ACTIONS.ADD_QUESTION:
      return {
        ...state,
        questionCount: state.questionCount + 1,
        masteryPoints: state.masteryPoints + (payload ? 1 : 0),
      };

    case REDUX_ACTIONS.RESET_QUESTIONS:
      return { ...state, questionCount: 0, masteryPoints: 0 };

    default:
      return state;
  }
};
